"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _HoverManager_eventEngine, _HoverManager_effectMaterialToken, _HoverManager_filter, _HoverManager_intersection, _HoverManager_node;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverManager = void 0;
const IInteractionEngine_1 = require("../../interfaces/IInteractionEngine");
const AbstractInteractionManager_1 = require("../AbstractInteractionManager");
const InteractionData_1 = require("../InteractionData");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const tsyringe_1 = require("tsyringe");
class HoverManager extends AbstractInteractionManager_1.AbstractInteractionManager {
    constructor() {
        // #region Properties (5)
        super(...arguments);
        _HoverManager_eventEngine.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.EventEngine));
        _HoverManager_effectMaterialToken.set(this, void 0);
        _HoverManager_filter.set(this, (interactionState) => {
            if (interactionState === IInteractionEngine_1.INTERACTION_STATE.MOVE) {
                return (node) => {
                    for (let i = 0; i < node.data.length; i++) {
                        if (node.data[i] instanceof InteractionData_1.InteractionData) {
                            if (node.data[i].interactionTypes['hover'])
                                return true;
                        }
                    }
                    return false;
                };
            }
            return (node) => false;
        });
        _HoverManager_intersection.set(this, null);
        _HoverManager_node.set(this, null);
        // #endregion Private Methods (2)
    }
    // #endregion Properties (5)
    // #region Public Accessors (1)
    get filter() {
        return __classPrivateFieldGet(this, _HoverManager_filter, "f");
    }
    // #endregion Public Accessors (1)
    // #region Public Methods (3)
    onDown(ray, intersection) { }
    onEnd(ray, intersection) { }
    onMove(ray, intersection) {
        let intersections = intersection.filter(i => this.filter(IInteractionEngine_1.INTERACTION_STATE.MOVE)(i.node));
        intersections = intersection.filter(i => {
            const data = i.node.data.find(d => d instanceof InteractionData_1.InteractionData);
            return !(data && data.interactionStates['drag'] === true);
        });
        if (__classPrivateFieldGet(this, _HoverManager_node, "f")) {
            if (intersections.length > 0 && intersection[0].node === __classPrivateFieldGet(this, _HoverManager_node, "f")) {
                // do nothing
            }
            else if (intersections.length > 0) {
                this.deactivateNode();
                this.activateNode(intersections[0]);
            }
            else {
                this.deactivateNode();
            }
        }
        else if (intersections.length > 0) {
            // easy case, no node hover, just hover this one
            this.activateNode(intersections[0]);
        }
    }
    // #endregion Public Methods (3)
    // #region Private Methods (2)
    /**
     * Utility function to make the node the current active node.
     * Set the according values, apply the effect and emit the event.
     *
     * @param intersection
     */
    activateNode(intersection) {
        __classPrivateFieldSet(this, _HoverManager_intersection, intersection, "f");
        __classPrivateFieldSet(this, _HoverManager_node, __classPrivateFieldGet(this, _HoverManager_intersection, "f").node, "f");
        const data = __classPrivateFieldGet(this, _HoverManager_node, "f").data.find(d => d instanceof InteractionData_1.InteractionData);
        if (data)
            data.interactionStates['hover'] = true;
        __classPrivateFieldSet(this, _HoverManager_effectMaterialToken, this.interactionEffectUtils.applyEffectMaterial(__classPrivateFieldGet(this, _HoverManager_node, "f"), this.effectMaterial), "f");
        __classPrivateFieldGet(this, _HoverManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.HOVER_ON, { node: __classPrivateFieldGet(this, _HoverManager_node, "f") });
        this.viewer.updateNode(__classPrivateFieldGet(this, _HoverManager_node, "f"));
        this.viewer.render();
    }
    /**
     * Utility function to make the node inactive.
     * Set the according values, remove the effect and emit the event.
     *
     * @param intersection
     */
    deactivateNode() {
        this.interactionEffectUtils.removeEffectMaterial(__classPrivateFieldGet(this, _HoverManager_node, "f"), __classPrivateFieldGet(this, _HoverManager_effectMaterialToken, "f"));
        this.viewer.updateNode(__classPrivateFieldGet(this, _HoverManager_node, "f"));
        this.viewer.render();
        const data = __classPrivateFieldGet(this, _HoverManager_node, "f").data.find(d => d instanceof InteractionData_1.InteractionData);
        if (data)
            data.interactionStates['hover'] = false;
        __classPrivateFieldGet(this, _HoverManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.HOVER_OFF, { node: __classPrivateFieldGet(this, _HoverManager_node, "f") });
        __classPrivateFieldSet(this, _HoverManager_intersection, null, "f");
        __classPrivateFieldSet(this, _HoverManager_node, null, "f");
    }
}
exports.HoverManager = HoverManager;
_HoverManager_eventEngine = new WeakMap(), _HoverManager_effectMaterialToken = new WeakMap(), _HoverManager_filter = new WeakMap(), _HoverManager_intersection = new WeakMap(), _HoverManager_node = new WeakMap();
//# sourceMappingURL=HoverManager.js.map